import React from "react";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import Select from "react-select";
import EssenceReference from "../../Essence/EssenceReference";

export default class PropertyEdit extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      measure: [],
      itemProperties: [],
      allProperties: [],
      pending: false,
      referenceShow: false,
    };
  }
  componentDidMount() {
    this.loadReferences().then(() => this.load());
  }

  componentDidUpdate(prevProps) {
    if (prevProps.objectId !== this.props.objectId) {
      this.load();
    }
  }
  getReferenceValue = (value, reference) => {
    if (Array.isArray(reference)) {
      return reference.find((item) => item.value === value) || null;
    }
    return {};
  };

  loadReferences = async () => {
    this.setState({ pending: true });
    let allProperties = [];
    let propsListQuery = await this.context.api.qa("/property/list", {
      search: [
        {
          field: "statetypecode",
          compare: "EQL",
          value: "enabled",
        },
      ],
    });
    if (Array.isArray(propsListQuery)) {
      propsListQuery.forEach((item) => {
        allProperties.push({
          value: item.id,
          label: item.label,
        });
      });
    }

    let measure = [];
    let measureQuery = await this.context.api.qa("/measure/list", {
      search: [
        {
          field: "statetypecode",
          compare: "EQL",
          value: "enabled",
        },
      ],
    });
    if (Array.isArray(measureQuery)) {
      measureQuery.forEach((item) => {
        measure.push({
          value: item.id,
          label: item.label,
        });
      });
    }

    this.setState({ allProperties, measure, pending: false });
  };

  load = async () => {
    this.setState({ pending: true });

    let filter = {};
    filter[this.props.referencekey] = this.props.objectId;

    let itemProperties = await this.context.api.qa(
      `/${this.props.reference}/property/list`,
      {
        filter,
        orderby: ["sequence ASC"],
      }
    );

    if (!itemProperties.length) {
      itemProperties.push(null);
    }

    this.setState({
      pending: false,
      itemProperties,
    });
  };

  onPropertyChange = (index, value) => {
    this.setState((state) => {
      let { itemProperties } = state;
      if (!itemProperties[index]) {
        itemProperties[index] = {};
      }
      itemProperties[index].propertyid = value;
      return { itemProperties };
    });
  };

  onMeasureChange = (index, value) => {
    this.setState((state) => {
      let { itemProperties } = state;
      if (!itemProperties[index]) {
        itemProperties[index] = {};
      }
      itemProperties[index].measureid = value;
      return { itemProperties };
    });
  };

  onValueChange = (index, value) => {
    this.setState((state) => {
      let { itemProperties } = state;
      if (!itemProperties[index]) {
        itemProperties[index] = {};
      }
      itemProperties[index].value = value;
      return { itemProperties };
    });
  };

  save = async () => {
    this.setState({ pending: true });
    let properties = [];
    this.state.itemProperties.forEach((item, idx) => {
      if (item) {
        item.sequence = idx;
        properties.push(item);
      }
    });
    await this.context.api.q(`/${this.props.reference}/property`, {
      id: this.props.objectId,
      properties,
    });
    this.load();
  };

  delete = ($index) => {
    this.setState((state) => {
      let { itemProperties } = state;
      itemProperties.splice($index, 1);
      return { itemProperties };
    });
  };

  add = () => {
    this.setState((state) => {
      let { itemProperties } = state;
      itemProperties.push(null);
      return { itemProperties };
    });
  };

  referenceHide = () => {
    this.setState({ referenceShow: false });
    this.loadReferences().then(() => this.load());
  };

  referenceShow = () => {
    this.setState({ referenceShow: true });
  };

  render() {
    let rows = [];
    for (let i = 0; i < this.state.itemProperties.length; i++) {
      let currProperty = this.state.itemProperties[i] || {};
      rows.push(
        <tr key={i}>
          <td width="45%">
            <Select
              value={this.getReferenceValue(
                currProperty.propertyid,
                this.state.allProperties
              )}
              onChange={(result) => this.onPropertyChange(i, result.value)}
              className="from-control react-select"
              classNamePrefix="react-select-inner"
              options={this.state.allProperties}
              placeholder="Свойство..."
              noOptionsMessage={({ inputValue }) =>
                `Ничего не найдено по запросу ${inputValue}`
              }
            />
          </td>
          <td width="20%">
            <Select
              value={this.getReferenceValue(
                currProperty.measureid,
                this.state.measure
              )}
              onChange={(result) => this.onMeasureChange(i, result.value)}
              className="from-control react-select"
              classNamePrefix="react-select-inner"
              options={this.state.measure}
              placeholder="ед."
              noOptionsMessage={({ inputValue }) =>
                `Ничего не найдено по запросу ${inputValue}`
              }
            />
          </td>
          <td>
            <input
              type="text"
              className="form-control"
              value={currProperty.value || ""}
              onChange={(e) => this.onValueChange(i, e.target.value)}
            />
          </td>
          <td>
            <i
              title="Очистить"
              onClick={() => this.delete(i)}
              className="fa fa-times text-muted text-hover-danger cursor-pointer"
            ></i>
          </td>
        </tr>
      );
    }

    return (
      <>
        {this.state.referenceShow && (
          <EssenceReference
            essence="property"
            sort="sequence"
            title="Свойства"
            showDescription
            editOnDblClick
            show={true}
            onHide={() => this.referenceHide()}
          />
        )}
        <Blocker on={this.state.pending}>
          <div className="pb-3"></div>
          <div>
            <table className="table">
              <tbody>
                {rows.map((row) => row)}
                <tr>
                  <td colSpan="4">
                    <div className="text-right">
                      <i
                        title="Добавить"
                        onClick={() => this.add()}
                        className="fa fa-plus text-muted text-hover-primary cursor-pointer"
                      ></i>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="mb-4 py-2 border-bottom"></div>
          <button onClick={this.save} className="btn btn-primary">
            Сохранить
          </button>
          <button
            title="Настройка свойств"
            onClick={this.referenceShow}
            className="btn btn-light btn-icon  ml-2"
          >
            <i className="fa fa-cogs"></i>
          </button>
        </Blocker>
      </>
    );
  }
}
